// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__PrkXx","filesListContainer":"PosDisputesFiles_filesListContainer__3wtoo","filesButton":"PosDisputesFiles_filesButton__3jiLV"};